import styled from 'styled-components'

export const OrderModalContainer = styled.div`
  color: ${({ theme }) => theme.FontColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  h2 {
    font-weight: 600;
    font-size: 18px;
  }
  p {
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    padding-bottom: 15px;
  }
`

export const ErrorContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 30px 24px 1fr;
  margin-top: 12px;
  grid-gap: 15px;
  justify-items: center;
  color: ${({ theme }) => theme.FontColor};
`

export const MWErrorContainer = styled(ErrorContainer)`
  justify-content: space-between;
  height: 100%;
  & div {
    width: 100%;
  }
`

export const AnimationContainer = styled.div`
  border-radius: 10px;
  overflow: hidden;
  width: 70vw;
`
